const createProductCardErrorText = (error: string) => `ProductCards:\n${error}`;
export default createProductCardErrorText;
